import { render, staticRenderFns } from "./ApplictionPromiseGoods.vue?vue&type=template&id=7fb2001f"
import script from "./ApplictionPromiseGoods.vue?vue&type=script&lang=js"
export * from "./ApplictionPromiseGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports